// src/pages/ShopsListingPage.jsx

import React, { useState } from 'react';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { FaSearch, FaFilter } from 'react-icons/fa';
import ShopCard from '../../../../components/user/shoppage/shopcard/ShopCard.js';
import { shopsData as ShopData } from '../../../../subscreens/users/shop/shopdata/ShopData';
import '../../../../assets/css/user/shoppage/shoplistingpage/ShopListingPage.css';

const ShopListingPage = () => {

  // ── States ──────────────────────────────────────────
  const [searchQuery, setSearchQuery]       = useState('');
  const [selectedLocation, setSelectedLocation] = useState('All');
  const [selectedRating, setSelectedRating]   = useState('All');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [currentPage, setCurrentPage]       = useState(1);
  const shopsPerPage = 4;

  // ── Unique Locations ─────────────────────────────────
  const locations = ['All', ...new Set(ShopData.map(shop => shop.location))];

  // ── Filter Logic ──────────────────────────────────────
  const filteredShops = ShopData.filter(shop => {
    const searchMatch =
      shop.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      shop.location.toLowerCase().includes(searchQuery.toLowerCase());

    const locationMatch =
      selectedLocation === 'All' || shop.location === selectedLocation;

    const ratingMatch =
      selectedRating === 'All' ||
      (selectedRating === '4+' && shop.rating >= 4) ||
      (selectedRating === '4.5+' && shop.rating >= 4.5);

    const categoryMatch =
      selectedCategory === 'All' || shop.category === selectedCategory;

    return searchMatch && locationMatch && ratingMatch && categoryMatch;
  });

  // ── Pagination Logic ──────────────────────────────────
  const totalPages    = Math.ceil(filteredShops.length / shopsPerPage);
  const indexOfFirst  = (currentPage - 1) * shopsPerPage;
  const indexOfLast   = indexOfFirst + shopsPerPage;
  const currentShops  = filteredShops.slice(indexOfFirst, indexOfLast);

  // ── Reset Filters ─────────────────────────────────────
  const resetFilters = () => {
    setSearchQuery('');
    setSelectedLocation('All');
    setSelectedRating('All');
    setSelectedCategory('All');
    setCurrentPage(1);
  };

  // ── Filter change ke waqt page 1 par wapis jayen ──────
  const handleLocationChange = (e) => { setSelectedLocation(e.target.value); setCurrentPage(1); };
  const handleRatingChange   = (e) => { setSelectedRating(e.target.value);   setCurrentPage(1); };
  const handleCategoryChange = (e) => { setSelectedCategory(e.target.value); setCurrentPage(1); };
  const handleSearchChange   = (e) => { setSearchQuery(e.target.value);      setCurrentPage(1); };

  // ── JSX ───────────────────────────────────────────────
  return (
    <div className="shops-listing-page">
      <Container>

        {/* Page Header */}
        <div className="page-header">
          <h1>Explore Rental Shops</h1>
          <p className="page-subtitle">
            Find trusted agricultural equipment rental services near you
          </p>
        </div>

        {/* Search & Filters */}
        <div className="search-filters-section">
          <Row className="align-items-end">

            <Col lg={4} md={6} className="mb-3">
              <div className="search-box">
                <FaSearch className="search-icon" />
                <Form.Control
                  type="text"
                  placeholder="Search shops by name or location..."
                  value={searchQuery}
                  onChange={handleSearchChange}
                  className="search-input"
                />
              </div>
            </Col>

            <Col lg={2} md={6} sm={6} className="mb-3">
              <Form.Label className="filter-label">Location</Form.Label>
              <Form.Select
                value={selectedLocation}
                onChange={handleLocationChange}
                className="filter-select"
              >
                {locations.map(loc => (
                  <option key={loc} value={loc}>{loc}</option>
                ))}
              </Form.Select>
            </Col>

            <Col lg={2} md={6} sm={6} className="mb-3">
              <Form.Label className="filter-label">Rating</Form.Label>
              <Form.Select
                value={selectedRating}
                onChange={handleRatingChange}
                className="filter-select"
              >
                <option value="All">All Ratings</option>
                <option value="4.5+">4.5+ Stars</option>
                <option value="4+">4+ Stars</option>
              </Form.Select>
            </Col>

            <Col lg={2} md={6} sm={6} className="mb-3">
              <Form.Label className="filter-label">Category</Form.Label>
              <Form.Select
                value={selectedCategory}
                onChange={handleCategoryChange}
                className="filter-select"
              >
                <option value="All">All Categories</option>
                <option value="Premium">Premium</option>
                <option value="Standard">Standard</option>
              </Form.Select>
            </Col>

            <Col lg={2} md={12} className="mb-3">
              <Button onClick={resetFilters} className="reset-filters-btn">
                Reset Filters
              </Button>
            </Col>

          </Row>
        </div>

        {/* Results Count */}
        <div className="results-info">
          Showing {filteredShops.length} {filteredShops.length === 1 ? 'shop' : 'shops'}
        </div>

        {/* Shops List — currentShops use karein, filteredShops nahi */}
        <Row>
          <Col lg={12}>
            {currentShops.map(shop => (
              <ShopCard key={shop.id} shop={shop} />
            ))}
          </Col>
        </Row>

        {/* No Results */}
        {filteredShops.length === 0 && (
          <div className="no-results">
            <FaFilter className="no-results-icon" />
            <h3>No Shops Found</h3>
            <p>Try adjusting your search or filters</p>
            <Button onClick={resetFilters} className="reset-btn-large">
              Reset All Filters
            </Button>
          </div>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="pagination-container">

            <Button
              className="pagination-btn"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(prev => prev - 1)}
            >
              Prev
            </Button>

            {Array.from({ length: totalPages }, (_, i) => (
              <Button
                key={i + 1}
                className={`pagination-btn ${currentPage === i + 1 ? 'active' : ''}`}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </Button>
            ))}

            <Button
              className="pagination-btn"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(prev => prev + 1)}
            >
              Next
            </Button>

          </div>
        )}

      </Container>
    </div>
  );
};

export default ShopListingPage;